import { FetchMiddleware } from './types';

export const createBaseUrlMiddleware = (opts: { baseUrl: string }): FetchMiddleware => {
  return (request) => {
    return { ...request, path: `${opts.baseUrl}${request.path}` };
  };
};
